// Shared constants matching backend
export const CANADIAN_CITIES = [
  'Toronto', 'Vancouver', 'Montreal', 'Calgary', 'Edmonton', 'Ottawa',
  'Winnipeg', 'Quebec City', 'Hamilton', 'Halifax', 'London', 'Kitchener',
  'Victoria', 'Regina', 'Saskatoon', "St. John's", 'Brampton', 'Mississauga',
  'Surrey', 'Markham', 'Laval', 'Burnaby', 'Richmond Hill', 'Vaughan',
];

export const BUSINESS_CATEGORIES = [
  { id: 'restaurants', name: 'Restaurants' },
  { id: 'salons', name: 'Hair & Beauty' },
  { id: 'groceries', name: 'Grocery Stores' },
  { id: 'events', name: 'Event Services' },
  { id: 'fashion', name: 'Fashion & Clothing' },
  { id: 'health', name: 'Health & Wellness' },
];

export const COMMUNITY_CATEGORIES = [
  { id: 'recreation', name: 'Recreation & Games' },
  { id: 'social', name: 'Social Groups' },
  { id: 'sports', name: 'Sports & Fitness' },
  { id: 'cultural', name: 'Cultural Groups' },
  { id: 'professional', name: 'Professional Networks' },
  { id: 'hobby', name: 'Hobby Clubs' },
  { id: 'faith', name: 'Faith & Spirituality' },
  { id: 'travel', name: 'Travel & Adventure' },
];

export const EVENT_CATEGORIES = [
  'Afrobeat Party', 'Networking Mixer', 'Cultural Festival', 'Church/Social Gathering',
  'Professional Event', 'Food & Lifestyle', 'Comedy Show', 'Music Concert', 'Art Exhibition',
];

// Convert files to base64 with size guard
export async function fileToDataUrl(file, maxBytes = 5 * 1024 * 1024) {
  if (file.size > maxBytes) {
    throw new Error(`${file.name} exceeds ${maxBytes / 1024 / 1024}MB`);
  }
  return new Promise((resolve, reject) => {
    const r = new FileReader();
    r.onload = () => resolve(r.result);
    r.onerror = reject;
    r.readAsDataURL(file);
  });
}
